module.exports = __webpack_public_path__ + "img/squishy-halloween-1.750ce04e.png";